export default __webpack_public_path__ + "static/media/keep ur skills.3daf141b.png";